import React from 'react';
import links from '../data/site-structure';
import { dubifyUrl } from '../header-utils';
import { StyledChannelSwitcher, StyledItem, StyledLink } from './channel-switcher.styled';
var channelLinks = links.sharedHeader.routeLinks;
var baseClassName = 'atds-channel-switcher';
var buildChannelLinks = function (onNavigationClick, notifications, channel, isNarrow, env) {
    var links = [];
    var selected = channel;
    Object.values(channelLinks).map(function (item, i) {
        var displayTextLowerCase = item.displayText.toLowerCase();
        var currentChannelCheck = selected === displayTextLowerCase || (selected === 'cycles' && displayTextLowerCase === 'electric bikes');
        var environment = env || 'prod';
        var url = dubifyUrl(item.url, channel, environment);
        links.push(React.createElement(StyledItem, { role: "none", key: "channel-".concat(i) },
            React.createElement(StyledLink, { drawer: !!isNarrow, routerLink: false, selected: currentChannelCheck, href: url, role: "menuitem", "aria-current": currentChannelCheck, trackingCallback: function () {
                    return onNavigationClick === null || onNavigationClick === void 0 ? void 0 : onNavigationClick({
                        labelIdentifier: displayTextLowerCase,
                    });
                } }, item.displayText)));
        return true;
    });
    return links;
};
export var ChannelSwitcher = function (_a) {
    var _b = _a.show, show = _b === void 0 ? true : _b, notifications = _a.notifications, channel = _a.channel, env = _a.env, isNarrow = _a.isNarrow, trackingCallbacks = _a.trackingCallbacks;
    return show ? (React.createElement(StyledChannelSwitcher, { as: "ul", drawer: !!isNarrow, className: "".concat(baseClassName, " atds-type-mini"), role: "menu", "aria-labelledby": "channel-switcher-heading" }, channelLinks &&
        buildChannelLinks(trackingCallbacks === null || trackingCallbacks === void 0 ? void 0 : trackingCallbacks.onNavigationClick, notifications, channel, isNarrow, env))) : null;
};
